<script>
export default {
  props: ['value'],
}
</script>

<template>
  {{ $d(value, 'long', $t('lang')) }}
</template>